








import {Component, Vue, Emit} from 'vue-property-decorator';

@Component
export default class FileHandle extends Vue{

    private file : any = null;
    private imageName : string = '';

    @Emit('handleFile')
    handleFile(changeEvent : any) : void {
        this.file = changeEvent.target.files[0];
        this.imageName = this.file.name
        return this.file
    }

    pickFile() : void {
        const elem : HTMLElement = this.$refs.file as HTMLElement;
        elem.click()
    }


    uploadFile() {

        if (this.file === null) {
            alert('이미지를 선택해주세요')
            return false
        }
        else {
            this.$emit('uploadFile', this.file)
        }

    }
}
